import React from "react";
import { cx } from "../utils";

/**
 * CcFormSection — bordered form block with optional icon + title (evaluation modal, etc.).
 */
const CcFormSection = ({
  title,
  icon = null,
  description,
  className,
  children,
  ...props
}) => (
  <section className={cx("cc-form-section", className)} {...props}>
    {(title || icon) && (
      <header className="cc-form-section__header">
        {icon ? <span className="cc-form-section__icon">{icon}</span> : null}
        <div className="cc-form-section__head-text">
          {title ? <h3 className="cc-form-section__title">{title}</h3> : null}
          {description ? (
            <p className="cc-form-section__description">{description}</p>
          ) : null}
        </div>
      </header>
    )}
    <div className="cc-form-section__body">{children}</div>
  </section>
);

export default CcFormSection;
